import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

/**
 * Submit button with a busy state. `Button` has none, which is why every add-repo modal
 * hand-rolled its own. Pair with useRepoSubmit and pass its isSubmitting.
 */
export const SubmitButton = React.forwardRef(
    (
        {
            text,
            submittingText = 'Submitting...',
            isSubmitting = false,
            disabled = false,
            icon,
            title,
            className = 'w-1/3',
        },
        ref
    ) => {
        const isBlocked = Boolean(isSubmitting) || Boolean(disabled);

        return (
            <button
                ref={ref}
                type='submit'
                disabled={isBlocked}
                title={isSubmitting ? 'Submission in progress' : title}
                className={`flex items-center justify-center rounded-full py-1.5 px-2.5 rounded-lg order bg-backgrounds-white shadow-inner border font-semibold ${className} ${
                    isBlocked
                        ? 'text-texts-secondary300 cursor-not-allowed'
                        : 'hover:bg-backgrounds-primary100 hover:border-backgrounds-primary200 text-backgrounds-primary400'
                }`}
            >
                {isSubmitting ? (
                    <FontAwesomeIcon icon={faSpinner} className='mr-2 animate-spin' />
                ) : (
                    icon && <FontAwesomeIcon icon={icon} className='mr-2' />
                )}
                {isSubmitting ? submittingText : text}
            </button>
        );
    }
);
